(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["petrazzo-whatsapp"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const support = document.querySelector('details.petrazzo-whatsapp[open]');
    if (support && event.target instanceof Node && !support.contains(event.target)) support.open = false;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const support = document.querySelector('details.petrazzo-whatsapp[open]');
    if (!support) return;
    const restoreFocus = support.contains(document.activeElement);
    support.open = false;
    if (restoreFocus) support.querySelector('summary').focus();
  });
  } catch(e) { console.error(e); }
})();

})();
